<template>
  <Layout>
    <PageHeader :title="title" :items="breadcrumbItems"/>

    <div class="row mb-3">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h4 class="header-title mb-0">Resumo Suspeita de Falhas</h4>
            <small class="text-muted">Dados baseados no período selecionado nos filtros</small>
          </div>
          <button
              class="btn btn-outline-primary btn-sm"
              @click="loadKpiData"
              :disabled="kpiLoading"
          >
            <i :class="kpiLoading ? 'uil uil-refresh mr-1' : 'uil uil-refresh mr-1'"></i>
            <span v-if="kpiLoading">Atualizando...</span>
            <span v-else>Atualizar KPIs</span>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3 col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-body p-0">
            <div class="media p-3">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold">Total de Falhas</span>
                <h2 class="mb-0">
                  <span v-if="kpiLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                  <span v-else-if="kpiError" class="text-muted">--</span>
                  <span v-else>{{ totalFailuresCount }}</span>
                </h2>
                <small class="text-muted">
                  <span v-if="!kpiLoading && !kpiError">
                    <i class="uil uil-clock mr-1"></i>
                    {{ totalPendingCount }} pendentes de avaliação
                  </span>
                </small>
              </div>
              <div class="align-self-center">
                <feather type="alert-triangle" class="icon-lg align-middle icon-dual-danger"></feather>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-body p-0">
            <div class="media p-3">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold">Pendentes de Verificação</span>
                <h2 class="mb-0">
                  <span v-if="kpiLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                  <span v-else-if="kpiError" class="text-muted">--</span>
                  <span v-else>{{ pendingFailureCheckCount }}</span>
                </h2>
                <small class="text-muted">
                  <span v-if="!kpiLoading && !kpiError">
                    <i class="uil uil-exclamation-triangle mr-1"></i>
                    Total de pendências
                  </span>
                </small>
              </div>
              <div class="align-self-center">
                <feather type="clock" class="icon-lg align-middle icon-dual-warning"></feather>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-body p-0">
            <div class="media p-3">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold">Não Comunicando</span>
                <h2 class="mb-0">
                  <span v-if="kpiLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                  <span v-else-if="kpiError" class="text-muted">--</span>
                  <span v-else>{{ notCommunicatingCount }}</span>
                </h2>
                <small class="text-muted">
                  <span v-if="!kpiLoading && !kpiError">
                    <i class="uil uil-clock mr-1"></i>
                    {{ getPendingCountForEffect('NotCommunicating') }} pendentes
                  </span>
                </small>
              </div>
              <div class="align-self-center">
                <feather type="wifi-off" class="icon-lg align-middle icon-dual-warning"></feather>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-body p-0">
            <div class="media p-3">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold">Sem Posição GPS</span>
                <h2 class="mb-0">
                  <span v-if="kpiLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                  <span v-else-if="kpiError" class="text-muted">--</span>
                  <span v-else>{{ noGpsPositionCount }}</span>
                </h2>
                <small class="text-muted">
                  <span v-if="!kpiLoading && !kpiError">
                    <i class="uil uil-clock mr-1"></i>
                    {{ getPendingCountForEffect('NoGPSPosition') }} pendentes
                  </span>
                </small>
              </div>
              <div class="align-self-center">
                <feather type="map-pin" class="icon-lg align-middle icon-dual-info"></feather>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-body p-0">
            <div class="media p-3">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold">Sem Telemetria</span>
                <h2 class="mb-0">
                  <span v-if="kpiLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                  <span v-else-if="kpiError" class="text-muted">--</span>
                  <span v-else>{{ noTelemetryCount }}</span>
                </h2>
                <small class="text-muted">
                  <span v-if="!kpiLoading && !kpiError">
                    <i class="uil uil-clock mr-1"></i>
                    {{ getPendingCountForEffect('NoTelemetry') }} pendentes
                  </span>
                </small>
              </div>
              <div class="align-self-center">
                <feather type="activity" class="icon-lg align-middle icon-dual-secondary"></feather>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-body p-0">
            <div class="media p-3">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold">Comportamento Inconsistente</span>
                <h2 class="mb-0">
                  <span v-if="kpiLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                  <span v-else-if="kpiError" class="text-muted">--</span>
                  <span v-else>{{ unexpectedBehaviorCount }}</span>
                </h2>
                <small class="text-muted">
                  <span v-if="!kpiLoading && !kpiError">
                    <i class="uil uil-clock mr-1"></i>
                    {{ getPendingCountForEffect('UnexpectedTelematicBehavior') }} pendentes
                  </span>
                </small>
              </div>
              <div class="align-self-center">
                <feather type="alert-circle" class="icon-lg align-middle icon-dual-warning"></feather>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-body p-0">
            <div class="media p-3">
              <div class="media-body">
                <span class="text-muted text-uppercase font-size-12 font-weight-bold">Horímetro Inconsistente</span>
                <h2 class="mb-0">
                  <span v-if="kpiLoading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                  <span v-else-if="kpiError" class="text-muted">--</span>
                  <span v-else>{{ inconsistentHourmeterCount }}</span>
                </h2>
                <small class="text-muted">
                  <span v-if="!kpiLoading && !kpiError">
                    <i class="uil uil-clock mr-1"></i>
                    {{ getPendingCountForEffect('InconsistentHourmeter') }} pendentes
                  </span>
                </small>
              </div>
              <div class="align-self-center">
                <feather type="clock" class="icon-lg align-middle icon-dual-info"></feather>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mb-4">Gerenciamento de Suspeita de Falhas</h4>

            <div class="row mb-3">
              <div class="col-md-3">
                <div class="form-group">
                  <label>Data Início</label>
                  <flat-pickr
                      v-model="filters.startDate"
                      class="form-control form-control-sm"
                      :config="dateConfig"
                      placeholder="Selecione a data"
                      @change="onDateChange"
                  ></flat-pickr>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label>Data Fim</label>
                  <flat-pickr
                      v-model="filters.endDate"
                      class="form-control form-control-sm"
                      :config="dateConfig"
                      placeholder="Selecione a data"
                      @change="onDateChange"
                  ></flat-pickr>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>Versão FW</label>
                  <b-form-input
                      v-model="filters.fwVersion"
                      type="text"
                      size="sm"
                      placeholder="Ex: 1.2.3"
                  ></b-form-input>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>Tipo de Efeito</label>
                  <b-form-select
                      v-model="filters.failureEffectId"
                      size="sm"
                      :options="failureEffectOptions"
                  ></b-form-select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>Sem Modo</label>
                  <b-form-select
                      v-model="filters.emptyFailureMode"
                      size="sm"
                      :options="[
                      { value: null, text: 'Todos' },
                      { value: true, text: 'Sim' },
                      { value: false, text: 'Não' }
                    ]"
                  ></b-form-select>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-12 col-md-6 col-lg-4">
                <div class="d-flex flex-wrap align-items-center">
                  <button
                      class="btn btn-primary btn-sm mr-2 mb-2 mb-lg-0"
                      @click="applyFilters"
                      :disabled="!isDateRangeValid"
                  >
                    <i class="uil uil-search mr-1"></i>Buscar
                  </button>
                  <button class="btn btn-secondary btn-sm mb-2 mb-lg-0" @click="clearFilters">
                    <i class="uil uil-redo mr-1"></i>Limpar
                  </button>
                </div>
              </div>
            </div>

            <div v-if="dateRangeMessage" class="row mb-3">
              <div class="col-12">
                <div class="alert alert-warning alert-dismissible fade show" role="alert">
                  <i class="uil uil-exclamation-triangle mr-2"></i>
                  {{ dateRangeMessage }}
                </div>
              </div>
            </div>

            <div class="row mb-md-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>&nbsp;registros
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                        v-model="searchFilter"
                        type="search"
                        placeholder="Buscar na tabela..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                  :items="filteredTableData"
                  :fields="tableFields"
                  :busy="isBusy"
                  responsive="sm"
                  striped
                  hover
                  show-empty
                  empty-text="Nenhuma falha encontrada"
              >
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Carregando...</strong>
                  </div>
                </template>

                <template #cell(id)="data">
                  <div class="d-flex align-items-center text-primary" style="cursor: pointer; text-decoration: none;"
                       @click="editFailure(data.item)">
                    <strong>{{ data.value }}</strong>
                  </div>
                </template>

                <template #cell(modemIdentifier)="data">
                  <div class="d-flex align-items-center">
                    <feather type="cpu" class="icon-xs mr-2 text-muted"></feather>
                    <strong>{{ data.value }}</strong>
                  </div>
                </template>

                <template #cell(failureEffectName)="data">
                  <span
                      class="badge"
                      :class="{
                      'badge-soft-danger': data.value === 'NotCommunicating',
                      'badge-soft-warning': data.value !== 'NotCommunicating'
                    }"
                  >
                    {{ data.value }}
                  </span>
                </template>

                <template #cell(failureModeName)="data">
                  <span
                      v-if="data.value"
                      class="badge badge-soft-info"
                  >
                    {{ data.value }}
                  </span>
                  <span v-else class="text-muted">
                    <i class="uil uil-minus"></i> Não definido
                  </span>
                </template>

                <template #cell(automatic)="data">
                  <span
                      class="badge"
                      :class="data.value ? 'badge-soft-success' : 'badge-soft-secondary'"
                  >
                    {{ data.value ? 'Automática' : 'Manual' }}
                  </span>
                </template>

                <template #cell(date)="data">
                  <div class="d-flex flex-column">
                    <small class="text-muted">{{ formatDate(data.value) }}</small>
                    <small class="text-muted">{{ formatTime(data.value) }}</small>
                  </div>
                </template>

                <template #cell(fwVersion)="data">
                  <span v-if="data.value" class="badge badge-soft-primary">
                    v{{ data.value }}
                  </span>
                  <span v-else class="text-muted">
                    <i class="uil uil-minus"></i>
                  </span>
                </template>

                <template #cell(actions)="data">
                  <b-dropdown variant="link" no-caret dropleft>
                    <template #button-content>
                      <i class="uil uil-ellipsis-v text-dark"/>
                    </template>

                    <b-dropdown-item @click="viewDetails(data.item)">
                      <i class="uil uil-eye mr-2"/>
                      <span>Ver Detalhes</span>
                    </b-dropdown-item>

                    <b-dropdown-item @click="editFailure(data.item)">
                      <i class="uil uil-edit mr-2"/>
                      <span>Editar Falha</span>
                    </b-dropdown-item>

                    <b-dropdown-item :to="`/device/${data.item.deviceId}`">
                      <i class="uil uil-server mr-2"/>
                      <span>Ir para Dispositivo</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_info">
                  Mostrando {{ showingFrom }} até {{ showingTo }} de {{ totalItems }} registros
                </div>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalItems"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
        ref="detailsModal"
        size="lg"
        title="Detalhes da Falha"
        ok-only
        ok-title="Fechar"
    >
      <div v-if="selectedFailure" class="container-fluid">
        <div class="row mb-3">
          <div class="col-md-12">
            <h6 class="text-muted">Identificador do Modem</h6>
            <p class="font-weight-bold">{{ selectedFailure.modemIdentifier }}</p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <h6 class="text-muted">Efeito da Falha</h6>
            <p>
              <span class="badge badge-soft-danger">
                {{ selectedFailure.failureEffectName }}
              </span>
            </p>
          </div>
          <div class="col-md-6">
            <h6 class="text-muted">Modo da Falha</h6>
            <p>
              <span v-if="selectedFailure.failureModeName" class="badge badge-soft-info">
                {{ selectedFailure.failureModeName }}
              </span>
              <span v-else class="text-muted">Não definido</span>
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <h6 class="text-muted">Data da Falha</h6>
            <p>{{ formatDate(selectedFailure.date) }} às {{ formatTime(selectedFailure.date) }}</p>
          </div>
          <div class="col-md-6">
            <h6 class="text-muted">Tipo de Detecção</h6>
            <p>
              <span
                  class="badge"
                  :class="selectedFailure.automatic ? 'badge-soft-success' : 'badge-soft-secondary'"
              >
                {{ selectedFailure.automatic ? 'Automática' : 'Manual' }}
              </span>
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <h6 class="text-muted">Versão do Firmware</h6>
            <p>
              <span v-if="selectedFailure.fwVersion" class="badge badge-soft-primary">
                v{{ selectedFailure.fwVersion }}
              </span>
              <span v-else class="text-muted">Não informado</span>
            </p>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        ref="editModal"
        size="lg"
        title="Editar Suspeita Falha"
        @show="onEditModalShow"
        @hidden="onEditModalHidden"
        @ok="saveFailure"
        ok-title="Salvar"
        cancel-title="Cancelar"
    >
      <div v-if="editingFailure" class="container-fluid">
        <b-form @submit.prevent="saveFailure">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Identificador da Falha</label>
                <b-form-input
                    v-model="editForm.id"
                    readonly
                    class="form-control-plaintext"
                ></b-form-input>
              </div>

            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Identificador do Modem</label>
                <b-form-input
                    v-model="editForm.modemIdentifier"
                    readonly
                    class="form-control-plaintext"
                ></b-form-input>
              </div>

            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Efeito da Falha</label>
                <b-form-input
                    v-model="editForm.failureEffectName"
                    readonly
                    class="form-control-plaintext"
                ></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Data da Falha</label>
                <b-form-input
                    :value="formatDate(editForm.date) + ' às ' + formatTime(editForm.date)"
                    readonly
                    class="form-control-plaintext"
                ></b-form-input>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Modo da Falha <span class="text-danger">*</span></label>
                <b-form-select
                    v-model="editForm.failureModeId"
                    :options="failureModeOptions"
                    :state="validation.failureModeId"
                    size="sm"
                ></b-form-select>
                <b-form-invalid-feedback v-if="!validation.failureModeId">
                  Selecione um modo de falha
                </b-form-invalid-feedback>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Origem da Falha</label>
                <b-form-select
                    v-model="editForm.failureOriginId"
                    :options="failureOriginOptions"
                    size="sm"
                    disabled
                ></b-form-select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Versão do Firmware</label>
                <b-form-input
                    v-model="editForm.fwVersion"
                    type="text"
                    size="sm"
                    placeholder="Ex: 1.2.3"
                ></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Tipo de Detecção</label>
                <b-form-input
                    :value="editForm.automatic ? 'Automática' : 'Manual'"
                    readonly
                    class="form-control-plaintext"
                ></b-form-input>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Intel ID</label>
                <b-form-input
                    v-model="editForm.intelId"
                    type="text"
                    size="sm"
                    placeholder="Intel ID"
                ></b-form-input>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>OBD ID</label>
                <b-form-input
                    v-model="editForm.obdId"
                    type="text"
                    size="sm"
                    placeholder="OBD ID"
                ></b-form-input>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>Notas</label>
                <b-form-textarea
                    v-model="editForm.note"
                    rows="3"
                    placeholder="Adicione observações sobre a falha..."
                ></b-form-textarea>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'
import {suspectedFailureApi} from "@router/apiFiles/suspectedFailureApi"

export default {
  page: {
    title: 'Suspected Failure Management',
    meta: [{name: 'description', content: appConfig.description}],
  },
  components: {Layout, PageHeader},

  data() {
    return {
      title: 'Gerenciamento de Suspeitas de Falhas ',
      breadcrumbItems: [
        {
          text: 'OnBoard',
          href: '/',
        },
        {
          text: 'Falhas',
          href: '/',
        },
        {
          text: 'Suspeitas de Falhas',
          active: true,
        },
      ],
      tableData: [],
      isBusy: true,
      totalItems: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100, 200, 250],
      searchFilter: '',
      kpiData: [],
      kpiLoading: true,
      kpiError: false,
      filters: {
        startDate: null,
        endDate: null,
        fwVersion: '',
        failureEffectId: null,
        emptyFailureMode: null,
      },
      dateConfig: {
        dateFormat: 'Y-m-d',
        allowInput: true,
      },
      failureEffectOptions: [
        {value: null, text: 'Todos'},
      ],
      failureModeOptions: [],
      failureOriginOptions: [],
      tableFields: [
        {key: 'id', label: 'Id', sortable: false},
        {key: 'modemIdentifier', label: 'Identificador', sortable: false},
        {key: 'failureEffectName', label: 'Efeito', sortable: false},
        {key: 'failureModeName', label: 'Modo', sortable: false},
        {key: 'automatic', label: 'Tipo', sortable: false},
        {key: 'date', label: 'Data', sortable: false},
        {key: 'fwVersion', label: 'FW Version', sortable: false},
        {key: 'actions', label: 'Ações', sortable: false},
      ],
      selectedFailure: null,
      editingFailure: null,
      editForm: {
        id: null,
        modemIdentifier: '',
        deviceId: '',
        failureEffectName: '',
        failureModeId: null,
        failureOriginId: null,
        fwVersion: '',
        intelId: '',
        obdId: '',
        note: '',
        date: '',
        automatic: false
      },
      validation: {
        failureModeId: null
      },
      searchTimeout: null,
    }
  },

  computed: {
    totalFailuresCount() {
      return this.kpiData.reduce((total, item) => total + item.countFailureEffect, 0)
    },

    notCommunicatingCount() {
      const item = this.kpiData.find(kpi => kpi.failureEffectName === 'NotCommunicating')
      return item ? item.countFailureEffect : 0
    },

    noGpsPositionCount() {
      const item = this.kpiData.find(kpi => kpi.failureEffectName === 'NoGPSPosition')
      return item ? item.countFailureEffect : 0
    },

    noTelemetryCount() {
      const item = this.kpiData.find(kpi => kpi.failureEffectName === 'NoTelemetry')
      return item ? item.countFailureEffect : 0
    },

    unexpectedBehaviorCount() {
      const item = this.kpiData.find(kpi => kpi.failureEffectName === 'UnexpectedTelematicBehavior')
      return item ? item.countFailureEffect : 0
    },

    inconsistentHourmeterCount() {
      const item = this.kpiData.find(kpi => kpi.failureEffectName === 'InconsistentHourmeter')
      return item ? item.countFailureEffect : 0
    },

    pendingFailureCheckCount() {
      return this.kpiData.reduce((total, item) => total + item.countPendingFailureCheck, 0)
    },

    totalPendingCount() {
      return this.kpiData.reduce((total, item) => total + item.countPendingFailureCheck, 0)
    },

    withoutFailureModeCount() {
      return this.tableData.filter(item => !item.failureModeName).length
    },

    filteredTableData() {
      // Não aplicar filtro de busca aqui, pois interfere com a paginação do servidor
      // O filtro de busca será aplicado via API quando necessário
      return this.tableData
    },

    showingFrom() {
      return this.totalItems === 0 ? 0 : (this.currentPage - 1) * this.perPage + 1
    },

    showingTo() {
      const to = this.currentPage * this.perPage
      return to > this.totalItems ? this.totalItems : to
    },

    isDateRangeValid() {
      if (!this.filters.startDate || !this.filters.endDate) {
        return true // Permitir busca sem datas (busca geral)
      }

      const startDate = new Date(this.filters.startDate)
      const endDate = new Date(this.filters.endDate)
      const diffTime = Math.abs(endDate - startDate)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      return diffDays <= 30 && startDate <= endDate
    },

    dateRangeMessage() {
      if (!this.filters.startDate || !this.filters.endDate) {
        return ''
      }

      const startDate = new Date(this.filters.startDate)
      const endDate = new Date(this.filters.endDate)

      if (startDate > endDate) {
        return 'A data de início não pode ser maior que a data de fim'
      }

      const diffTime = Math.abs(endDate - startDate)
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

      if (diffDays > 30) {
        return `Período de ${diffDays} dias excede o limite de 30 dias`
      }

      return ''
    }
  },

  methods: {
    async loadKpiData() {
      this.kpiLoading = true
      this.kpiError = false

      try {
        const response = await suspectedFailureApi.fetchRecentSuspectedFailureSummary({
          startDate: this.filters.startDate,
          endDate: this.filters.endDate
        })
        this.kpiData = response.data || []
      } catch (error) {
        console.error('Erro ao carregar KPIs:', error)
        this.kpiError = true
        this.makeToast('Erro ao carregar dados dos KPIs', 'danger')
      } finally {
        this.kpiLoading = false
      }
    },

    searchSuspectedFailures() {
      this.isBusy = true

      suspectedFailureApi.searchSuspectedFailures({
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        fwVersion: this.filters.fwVersion,
        failureEffectId: this.filters.failureEffectId,
        emptyFailureMode: this.filters.emptyFailureMode,
        searchFilter: this.searchFilter, // Incluir filtro de busca na API
        page: this.currentPage,
        perPage: this.perPage,
      })
          .then(result => {
            this.tableData = result.data || []
            this.totalItems = result.totalItems || 0
            // Não precisa mais extrair os efeitos da tabela, pois agora carregamos via API
          })
          .catch(error => {
            console.error('Erro ao buscar falhas:', error)
            this.makeToast('Erro ao carregar dados de falhas suspeitas', 'danger')
          })
          .finally(() => {
            this.isBusy = false
          })
    },

    applyFilters() {
      // Validar período de datas antes de aplicar filtros
      if (!this.isDateRangeValid) {
        this.makeToast(this.dateRangeMessage, 'warning')
        return
      }

      this.currentPage = 1
      this.searchSuspectedFailures()
      this.loadKpiData()
    },

    clearFilters() {
      this.setDefaultDates()
      this.filters = {
        ...this.filters,
        fwVersion: '',
        failureEffectId: null,
        emptyFailureMode: null,
      }
      this.searchFilter = ''
      this.currentPage = 1
      this.searchSuspectedFailures()
      this.loadKpiData()
    },

    async loadFailureEffectOptions() {
      try {
        const failureEffects = await suspectedFailureApi.getSuspectedFailureEffects()
        this.failureEffectOptions = [
          {value: null, text: 'Todos'},
          ...failureEffects.data.map(item => ({
            value: item.value,
            text: item.label
          }))
        ]
      } catch (error) {
        console.error('Erro ao carregar efeitos de falha:', error)
        // Fallback para o método anterior se a API não estiver disponível
        this.extractFailureEffectOptions()
      }
    },

    extractFailureEffectOptions() {
      const uniqueEffects = new Set()
      this.tableData.forEach(item => {
        if (item.failureEffectId && item.failureEffectName) {
          uniqueEffects.add(JSON.stringify({
            value: item.failureEffectId,
            text: item.failureEffectName
          }))
        }
      })

      this.failureEffectOptions = [
        {value: null, text: 'Todos'},
        ...Array.from(uniqueEffects).map(item => JSON.parse(item))
      ]
    },

    viewDetails(failure) {
      this.selectedFailure = failure
      this.$refs.detailsModal.show()
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleDateString('pt-BR')
    },

    formatTime(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleTimeString('pt-BR')
    },

    makeToast(msg, variant = 'info') {
      this.$bvToast.toast(msg, {
        title: 'Informação',
        variant: variant,
        autoHideDelay: 3000,
        solid: true,
      })
    },

    getPendingCountForEffect(effectName) {
      const item = this.kpiData.find(kpi => kpi.failureEffectName === effectName)
      return item ? item.countPendingFailureCheck : 0
    },

    formatDateForInput(date) {
      return date.toISOString().split('T')[0]
    },

    setDefaultDates() {
      const today = new Date()
      const thirtyDaysAgo = new Date()
      thirtyDaysAgo.setDate(today.getDate() - 30)

      this.filters.startDate = this.formatDateForInput(thirtyDaysAgo)
      this.filters.endDate = this.formatDateForInput(today)
    },

    onDateChange() {
      // Validação em tempo real quando as datas mudam
      if (this.filters.startDate && this.filters.endDate) {
        const startDate = new Date(this.filters.startDate)
        const endDate = new Date(this.filters.endDate)

        if (startDate > endDate) {
          // Não mostrar toast aqui, apenas deixar a mensagem visual
          return
        }

        const diffTime = Math.abs(endDate - startDate)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        if (diffDays > 30) {
          // Não mostrar toast aqui, apenas deixar a mensagem visual
          return
        }
      }
    },

    async editFailure(failure) {
      console.log('failure: ', failure)
      try {
        // Buscar dados completos da falha
        const fullFailureData = await suspectedFailureApi.getSuspectedFailure({id: failure.id})

        this.editingFailure = fullFailureData

        // Preencher formulário com dados da falha
        this.editForm = {
          id: fullFailureData.id,
          modemIdentifier: fullFailureData.modemIdentifier || '',
          deviceId: fullFailureData.deviceId || '',
          failureEffectName: fullFailureData.failureEffectName || '',
          failureModeId: fullFailureData.failureModeId || null,
          failureOriginId: fullFailureData.failureOriginId || null,
          fwVersion: fullFailureData.fwVersion || '',
          intelId: fullFailureData.intelId ? fullFailureData.intelId.toString() : '',
          obdId: fullFailureData.obdId ? fullFailureData.obdId.toString() : '',
          note: fullFailureData.note || '',
          date: fullFailureData.date || '',
          automatic: fullFailureData.automatic || false
        }

        // Mostrar modal (as opções já foram carregadas no mounted)
        this.$refs.editModal.show()
      } catch (error) {
        console.error('Erro ao carregar dados da falha:', error)
        this.makeToast('Erro ao carregar dados da falha para edição', 'danger')
      }
    },

    async loadSelectOptions() {
      try {
        // Carregar modos de falha
        const failureModes = await suspectedFailureApi.getSuspectedFailureModes()
        this.failureModeOptions = [
          {value: null, text: 'Selecione um modo de falha'},
          ...failureModes.data.map(item => ({
            value: item.value,
            text: item.label
          }))
        ]

        // Carregar origens de falha
        const failureOrigins = await suspectedFailureApi.getSuspectedFailureOrigin()
        this.failureOriginOptions = [
          {value: null, text: 'Selecione uma origem'},
          ...failureOrigins.data.map(item => ({
            value: item.value,
            text: item.label
          }))
        ]
      } catch (error) {
        console.error('Erro ao carregar opções dos selects:', error)
        this.makeToast('Erro ao carregar opções dos selects', 'warning')

        // Definir opções padrão em caso de erro
        this.failureModeOptions = [
          {value: null, text: 'Erro ao carregar modos de falha'}
        ]
        this.failureOriginOptions = [
          {value: null, text: 'Erro ao carregar origens de falha'}
        ]
      }
    },

    onEditModalShow() {
      this.resetValidation()
    },

    onEditModalHidden() {
      this.editingFailure = null
      this.resetEditForm()
      this.resetValidation()
    },

    resetEditForm() {
      this.editForm = {
        id: null,
        modemIdentifier: '',
        deviceId: '',
        failureEffectName: '',
        failureModeId: null,
        failureOriginId: null,
        fwVersion: '',
        intelId: '',
        obdId: '',
        note: '',
        date: '',
        automatic: false
      }
    },

    resetValidation() {
      this.validation = {
        failureModeId: null
      }
    },

    validateForm() {
      this.validation.failureModeId = this.editForm.failureModeId !== null && this.editForm.failureModeId !== ''
      return this.validation.failureModeId
    },

    async saveFailure(bvModalEvt) {
      // Prevenir fechamento do modal se houver erro de validação
      if (!this.validateForm()) {
        bvModalEvt.preventDefault()
        return
      }

      try {
        const updateData = {
          id: this.editForm.id,
          failureModeId: this.editForm.failureModeId,
          note: this.editForm.note,
          fwVersion: this.editForm.fwVersion,
          intelId: this.editForm.intelId ? parseInt(this.editForm.intelId) : null,
          obdId: this.editForm.obdId ? parseInt(this.editForm.obdId) : null
        }

        await suspectedFailureApi.updateSuspectedFailure(updateData)

        this.makeToast('Falha atualizada com sucesso!', 'success')
        this.$refs.editModal.hide()

        // Recarregar dados da tabela e KPIs
        this.searchSuspectedFailures()
        this.loadKpiData()

      } catch (error) {
        console.error('Erro ao salvar falha:', error)
        this.makeToast('Erro ao salvar alterações', 'danger')
        bvModalEvt.preventDefault()
      }
    },
  },

  watch: {
    currentPage() {
      this.searchSuspectedFailures()
    },

    perPage() {
      this.currentPage = 1
      this.searchSuspectedFailures()
    },
  },

  async mounted() {
    this.setDefaultDates()
    await this.loadKpiData()
    await this.loadFailureEffectOptions()
    await this.loadSelectOptions()
    this.searchSuspectedFailures()
  }
}
</script>

<style scoped lang="scss">
.icon-xs {
  width: 16px;
  height: 16px;
}

.icon-lg {
  width: 48px;
  height: 48px;
}

.dataTables_info {
  padding-top: 0.85em;
  font-size: 0.875rem;
  color: #6c757d;
}

.badge-soft-danger {
  color: #f1556c;
  background-color: rgba(241, 85, 108, 0.18);
}

.badge-soft-warning {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.18);
}

.badge-soft-info {
  color: #4fc6e1;
  background-color: rgba(79, 198, 225, 0.18);
}

.badge-soft-success {
  color: #0acf97;
  background-color: rgba(10, 207, 151, 0.18);
}

.badge-soft-secondary {
  color: #6c757d;
  background-color: rgba(108, 117, 125, 0.18);
}

.badge-soft-primary {
  color: #5369f8;
  background-color: rgba(83, 105, 248, 0.18);
}

.icon-dual-danger {
  color: #f1556c;
}

.icon-dual-warning {
  color: #f7b84b;
}

.icon-dual-info {
  color: #4fc6e1;
}

.icon-dual-secondary {
  color: #6c757d;
}

.icon-dual-success {
  color: #0acf97;
}

// Estilos para os cards de KPI
.card.h-100 {
  transition: all 0.3s ease;
  border: 1px solid #e3e6f0;
}

.card.h-100:hover {
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
  transform: translateY(-2px);
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

// Melhorar responsividade dos cards
@media (max-width: 768px) {
  .col-lg-3 {
    margin-bottom: 1rem;
  }
}

// Animações suaves para os números dos KPIs
h2 {
  transition: all 0.3s ease;
}

// Estilo para o botão de refresh
.btn-outline-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
</style>